import axios from 'axios';
import qs from 'qs';
import { log } from 'util';


// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};

//线上
const baseUrl = 'https://b2b.naturehike.cn/camp'

// //测试环境
// const baseUrl = 'http://171.168.1.207:8080/camp'

// 自定义post请求
const reqPost = (url, data) => {
  return axios({
    method: 'post',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: data,
  }).then((res) => {
    return res.data
  })
};

// 自定义get请求
const reqMyGet = (url, params) => {
  return axios({
    method: 'get',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
  }).then((res) => {
    return res.data
  })
};


const req = (method, url, params) => {
  return axios({
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};

// 通用公用方法
const mapbaseUrl = 'https://restapi.amap.com/v3'
const mapreq = (method, url, params) => {
  return axios({
    method: method,
    url: mapbaseUrl + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};

// 支付公用方式
const alipayReq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      // token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    // transformRequest: [
    //     function (data) {
    //         let ret = ''
    //         for (let it in data) {
    //             ret +=
    //                 encodeURIComponent(it) +
    //                 '=' +
    //                 encodeURIComponent(data[it]) +
    //                 '&'
    //         }
    //         return ret
    //     }
    // ]
  }).then(res => res.data);
};

const reqGet = (method, url, params) => {
  let ret = ''
  for (let it in params) {
    ret +=
      encodeURIComponent(it) +
      '=' +
      encodeURIComponent(params[it]) +
      '&'
  }
  return axios({
    method: method,
    url: baseUrl + url + `?${ret}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [  // 这个更改请求参数只能作用与 put post 和PATCH请求方法
      (data) => {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};

const jsonReq = (method, url, params) => {
  return axios({
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      // token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
  }).then(res => res.data);
};

export {
  loginreq,
  req,
  mapreq,
  alipayReq,
  reqGet,
  reqMyGet,
  jsonReq,
  reqPost,
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js